import { StrictMode } from 'react';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App.tsx';
import { AuthProvider } from './lib/authStore.tsx';
import { queryClient } from './lib/queryClient.tsx';
import { strings } from './lib/strings.tsx';

async function enableMocksIfConfigured(): Promise<void> {
  // 실제 제어 API 없이도 화면이 서도록 하는 대역 계층(MSW). 명시적으로 켠 경우에만 동작함.
  if (import.meta.env.VITE_USE_MOCKS !== 'true') return;
  const { worker } = await import('./mocks/browser.tsx');
  await worker.start({ onUnhandledRequest: 'bypass' });
}

enableMocksIfConfigured().then(() => {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error(strings.main.rootElementNotFound);
  createRoot(rootEl).render(
    <StrictMode>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </QueryClientProvider>
      </AuthProvider>
    </StrictMode>,
  );
});
